const getResponsive = (size, defaultValue, mobile = false, unit = 'px') => {
    if (!size) return defaultValue
    if (!`${size}`.includes('|')) return `${size}${unit}`
    const sizes = size.split('|')
    if (!mobile) return `${sizes[0]}${unit}`
    return `${sizes[1]}${unit}` || `${sizes[0]}${unit}`
}

export default getResponsive
